import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { DrawerHeader } from 'components/drawer-header'
import { setData, setDrawer, setHeaderVisibility, setStage } from 'slices/drawer'
import { DRAWER_KEY, NOTIFICATION_DEFAULT_CATEGORIES } from 'app-constants'
import { Message, Messages } from './components'
import { MESSAGES_DRAWER_STAGES } from './constants'

export function MessagesDrawer() {
  const [selected, setSelected] = useState({})
  const [selectedCategory, setSelectedCategory] = useState(NOTIFICATION_DEFAULT_CATEGORIES.ALL)
  const { stage, data } = useSelector(({ drawer }) => drawer)
  const messages = useSelector(state => state.messages)
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setHeaderVisibility(false))
  }, [dispatch])

  useEffect(() => {
    if (data.id) {
      setSelected(data)
      dispatch(setStage(MESSAGES_DRAWER_STAGES.MESSAGE))
      dispatch(setData({}))
    }
  }, [dispatch, data])

  function handleDrawerClose() {
    dispatch(setDrawer(DRAWER_KEY.NONE))
  }

  function renderContent() {
    return stages({
      selected,
      setSelected,
      messages,
      selectedCategory,
      setSelectedCategory,
    })[stage]
  }

  return (
    <>
      <DrawerHeader title='Notificações' onClose={handleDrawerClose} />
      {renderContent()}
    </>
  )
}

function stages({ ...props }) {
  return {
    [MESSAGES_DRAWER_STAGES.INITIAL]: <Messages {...props} />,
    [MESSAGES_DRAWER_STAGES.MESSAGE]: <Message {...props} />,
  }
}
